import React from 'react';
import './styles.scss';

const AboutUsHeroSection = () => {
  return (
    <section className="__AboutUsHeroSection d-flex flex-column align-items-center text-center justify-content-center position-relative">
      <div className="__my-container">
        {/* <h1 className="__title font_montserrat font-weight-normal">Welcome to Urbain</h1>
        <h1 className="__main-title font_corben font-weight-bold">Stay delighted.</h1>
        <h5 className="font_montserrat font-weight-mediam-bold __subtitle mt-3 d-none d-lg-block">It sounds simple, but it means everything.</h5> */}
      </div>
    </section>
  );
};

export default AboutUsHeroSection;
